(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yg-anchor-item"] && !Shopify.designMode) return;
  try {
    class YGAnchorItem extends HTMLElement {
      #observedSection = null;
      static observer = null;
      static sectionToItem = new Map();
      static isScroll = false;

      constructor() {
        super();
        this.itemClick = this.itemClick.bind(this);
        this.sections = null;
      }

      connectedCallback() {
        this.sections = document.querySelectorAll('#main .shopify-section');
        this.addEventListener('click', this.itemClick);

        const sectionNumber = Number(this.getAttribute('data-section-number') || 0);
        if (!this.sections?.length || !Number.isFinite(sectionNumber) || sectionNumber <= 0) return;

        const section = this.sections[sectionNumber - 1];
        if (!section) return;

        this.#observedSection = section;
        YGAnchorItem.#ensureObserver();
        YGAnchorItem.sectionToItem.set(section, this);
        YGAnchorItem.observer.observe(section);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);

        if (this.#observedSection && YGAnchorItem.observer) {
          YGAnchorItem.sectionToItem.delete(this.#observedSection);
          YGAnchorItem.observer.unobserve(this.#observedSection);
        }
      }

      static #ensureObserver() {
        if (YGAnchorItem.observer) return;

        YGAnchorItem.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const item = YGAnchorItem.sectionToItem.get(entry.target);
              if (!YGAnchorItem.isScroll) {
                item && item.setActiveFromObserver();
              }
            });
          },
          {
            root: null,
            threshold: 0.01,
            rootMargin: '-20% 0px -70% 0px',
          }
        );
      }

      setActiveFromObserver() {
        let id = this.getAttribute('data-id');
        let $anchorList;
        if (id) {
          $anchorList = this.parentElement
            ? Array.from(document.querySelectorAll(`yg-anchor-item[data-id="${id}"]`))
            : [];
        } else {
          $anchorList = this.parentElement
            ? Array.from(this.parentElement.querySelectorAll('yg-anchor-item'))
            : [];
        }

        $anchorList.forEach((el, index) => {
          el.classList.toggle('active', el.getAttribute('data-section-number') === this.getAttribute('data-section-number'));

          if (el === this) {
            this.labelClick(index);
          }
        });

        document.dispatchEvent(new CustomEvent('YG:anchor-change', {
          bubbles: true,
        }));
      }

      labelClick(index) {
        // 添加新的活动状态
        const parent = this.parentElement;
        if (parent && this.isScrollable(parent)) {
          const containerRect = parent.getBoundingClientRect();
          const targetRect = this.getBoundingClientRect();
          const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 260;

          parent.scrollTo({
            left: scrollLeft,
            behavior: 'smooth',
          });
        }
      }

      isScrollable(el) {
        if (!el) return false;

        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        const overflowX = style.overflowX;

        const canScrollVertically =
          (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
        const canScrollHorizontally =
          (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;

        return canScrollVertically || canScrollHorizontally;
      }

      itemClick() {
        const sectionNumber = this.getAttribute('data-section-number');
        YGAnchorItem.isScroll = true;
        this.setActiveFromObserver();
        if (sectionNumber == 0) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        } else {
          const section = this.sections[sectionNumber - 1];
          if (!section) return;
          const offsetTop = section.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }

        setTimeout(() => {
          YGAnchorItem.isScroll = false;
        }, 600);
      }
    }
    if (!window.customElements.get('yg-anchor-item')) {
      window.customElements.define('yg-anchor-item', YGAnchorItem);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-collapse-button"] && !Shopify.designMode) return;
  try {
    class YGCollapseButton extends HTMLElement {
    #sectionEl;
    constructor() {
        super()
        this.itemClick = this.itemClick.bind(this)
    }

    get $sectionEl() {
      // if (this.#sectionEl) return this.#sectionEl

      this.#sectionEl = {
        'targetEl': document.querySelector(`.${this.getAttribute('data-target-class')}`),
        'buttonLabel': this.querySelector('.yg-link-label')
      }

      return this.#sectionEl
    }

    get collapsedHeight() {
      return Number(this.getAttribute('data-collapsed-height')) || 0
    }

    connectedCallback() {
        if (!this.$sectionEl['targetEl']) return
        this.init()
        this.addEventListener('click', this.itemClick);
        this.$sectionEl['targetEl'].addEventListener('click', ()=>{this.init()})
    }
    disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);
    }

    init() {
      const target = this.$sectionEl['targetEl'];
      const buttonLabel = this.$sectionEl['buttonLabel'];

      if (!target.classList.contains('yg-collapse-target-el')) {
        target.classList.add('yg-collapse-target-el');
      }

      if (target.hasAttribute('open')) {
        target.style.height = 'auto';
        this.setAttribute('open', '');
        if (buttonLabel) {
          buttonLabel.innerText = this.getAttribute("data-less-label")
        }
      } else {
        target.style.height = `${this.collapsedHeight}px`;
        this.removeAttribute('open');
        if (buttonLabel) {
          buttonLabel.innerText = this.getAttribute("data-more-label")
        }
      }
    }

    openSection() {
      let target = this.$sectionEl['targetEl'];
      let buttonLabel = this.$sectionEl['buttonLabel'];

      // 先把高度设为当前像素值，再过渡到内容高度
      target.style.height = target.offsetHeight + 'px';
      
      // 强制浏览器重新计算一次布局，确保过渡生效
      target.offsetHeight;

      const endHeight = target.scrollHeight;
      target.style.height = endHeight + 'px';
      target.setAttribute('open', '');
      this.setAttribute('open', '');
      buttonLabel.innerText = this.getAttribute("data-less-label")

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;
        target.style.height = 'auto'; // 过渡结束后改为 auto，后续内容高度变化自动适应
        target.removeEventListener('transitionend', onTransitionEnd);
      };

      target.addEventListener('transitionend', onTransitionEnd);
    }

    closeSection() {
      const target = this.$sectionEl['targetEl'];
      const buttonLabel = this.$sectionEl['buttonLabel'];

      // 防止重复关闭
      if (!target.hasAttribute('open')) return;

      this.removeAttribute('open');
      buttonLabel.innerText = this.getAttribute("data-more-label")

      // 从 auto 变成具体高度，再过渡到 0
      if (getComputedStyle(target).height === 'auto') {
        target.style.height = target.scrollHeight + 'px';
      } else if (!target.style.height || target.style.height === `${this.collapsedHeight}px`) {
        target.removeAttribute('open');
        target.style.height = `${this.collapsedHeight}px`;
        return;
      }

      // 强制重新计算
      target.offsetHeight;

      target.style.height = `${this.collapsedHeight}px`;
      target.removeAttribute('open');
      this.removeAttribute('open');
      buttonLabel.innerText = this.getAttribute("data-more-label")
    }

    itemClick() {
      const target = this.$sectionEl['targetEl'];
      if (target.hasAttribute('open')) {
        this.closeSection();
      } else {
        this.openSection();
      }
    }
  }
  if (!window.customElements.get('yg-collapse-button')) {
    window.customElements.define('yg-collapse-button', YGCollapseButton)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-count-down"] && !Shopify.designMode) return;
  try {
    class YGCountDown extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.hasExpired = false;
    }

    connectedCallback() {
      this.targetDate = this.parseDate(this.dataset.date);

      if (!this.targetDate) {
        this.hidden = true;
        return;
      }

      this.updateCountdown();

      if (!this.hasExpired) {
        this.timer = window.setInterval(() => this.updateCountdown(), 1000);
      }
    }

    disconnectedCallback() {
      this.clearTimer();
    }

    parseDate(rawDate) {
      if (!rawDate) return null;

      const normalizedDate = rawDate.includes('T') ? rawDate : rawDate.replace(/-/g, '/');
      const parsedDate = new Date(normalizedDate);

      return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    }

    clearTimer() {
      if (!this.timer) return;

      window.clearInterval(this.timer);
      this.timer = null;
    }

    get itemMap() {
      if (this._itemMap) return this._itemMap;

      this._itemMap = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]')
      };

      return this._itemMap;
    }

    updateCountdown() {
      const diff = this.targetDate.getTime() - Date.now();

      if (diff <= 0) {
        this.handleExpiration();
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.renderValue(this.itemMap.days, days);
      this.renderValue(this.itemMap.hours, hours);
      this.renderValue(this.itemMap.minutes, minutes);
      this.renderValue(this.itemMap.seconds, seconds);
    }

    renderValue(element, value) {
      if (!element) return;
      element.textContent = String(value).padStart(2, '0');
    }

    handleExpiration() {
      if (this.hasExpired) return;

      this.hasExpired = true;
      this.clearTimer();

      if (this.dataset.endAction === 'hide_block' && this.dataset.blockId) {
        this.dispatchEvent(
          new CustomEvent('yg:announcement-block-expired', {
            bubbles: true,
            detail: {
              blockId: this.dataset.blockId
            }
          })
        );
        return;
      }

      this.hidden = true;
    }
  }

  (() => {
    const boot = () => {
      if (!window.customElements.get('yg-count-down')) {
        window.customElements.define('yg-count-down', YGCountDown);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-dot-v1"] && !Shopify.designMode) return;
  try {
    class YGDotV1 extends HTMLElement {
    static activeLockOwner = null;
    static lockedScrollY = 0;
    static mobileTransitionDuration = 280;

    constructor() {
      super();
      this.handleButtonClick = this.handleButtonClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleOverlayClick = this.handleOverlayClick.bind(this);
    }

    connectedCallback() {
      if (this.isConnectedSetup) return;

      this.isConnectedSetup = true;
      this.buttonElement = this.querySelector('.yg-dot-v1__button');
      this.cardShellElement = this.querySelector('.yg-dot-v1__card-shell');
      this.closeButtonElement = this.querySelector('.yg-dot-v1__close');
      this.mobileOverlayElement = this.querySelector('.yg-dot-v1__mobile-overlay');
      this.portalStyleSourceElement = this.closest('yg-banner-tabs-v1');
      this.cardShellOriginParent = this.cardShellElement?.parentNode || null;
      this.cardShellOriginNextSibling = this.cardShellElement?.nextSibling || null;
      this.overlayOriginParent = this.mobileOverlayElement?.parentNode || null;
      this.overlayOriginNextSibling = this.mobileOverlayElement?.nextSibling || null;

      this.button?.addEventListener('click', this.handleButtonClick);
      this.closeButton?.addEventListener('click', this.handleCloseClick);
      this.mobileOverlay?.addEventListener('click', this.handleOverlayClick);
      window.addEventListener('resize', this.handleResize, { passive: true });
      document.addEventListener('click', this.handleDocumentClick);

      if (this.isDefaultOpen) {
        requestAnimationFrame(() => this.open(false));
      } else {
        this.close(false);
      }
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleButtonClick);
      this.closeButton?.removeEventListener('click', this.handleCloseClick);
      this.mobileOverlay?.removeEventListener('click', this.handleOverlayClick);
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('click', this.handleDocumentClick);
      this.clearMobileCloseTimer();
      this.hideMobileLayer();
      if (this.mobileOverlay) {
        this.mobileOverlay.hidden = true;
      }
      if (this.cardShell) {
        this.cardShell.hidden = true;
      }
      this.restoreMobileLayer();
      YGDotV1.unlockBodyScroll(this);
      this.isConnectedSetup = false;
    }

    get button() {
      return this.buttonElement || this.querySelector('.yg-dot-v1__button');
    }

    get cardShell() {
      return this.cardShellElement || this.querySelector('.yg-dot-v1__card-shell');
    }

    get closeButton() {
      return this.closeButtonElement || this.querySelector('.yg-dot-v1__close');
    }

    get mobileOverlay() {
      return this.mobileOverlayElement || this.querySelector('.yg-dot-v1__mobile-overlay');
    }

    get isDefaultOpen() {
      return this.dataset.defaultOpen === 'true';
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    handleButtonClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.toggle();
    }

    handleDocumentClick(event) {
      if (!this.isOpen || this.isEventInside(event.target)) return;
      this.close();
    }

    handleCloseClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.close();
    }

    handleOverlayClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.close();
    }

    handleResize() {
      if (!this.isOpen) return;

      if (this.isMobile) {
        this.syncPortalStyles();
        this.mountMobileLayer();
        this.showMobileLayer();
        YGDotV1.lockBodyScroll(this);
      } else {
        this.hideMobileLayer();
        if (this.mobileOverlay) {
          this.mobileOverlay.hidden = true;
        }
        this.restoreMobileLayer();
        YGDotV1.unlockBodyScroll(this);
        if (this.cardShell) {
          this.cardShell.hidden = false;
        }
      }

      this.updatePlacement();
    }

    get isMobile() {
      return window.innerWidth <= 699;
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open(emitEvent = true) {
      this.clearMobileCloseTimer();

      if (this.isMobile) {
        this.syncPortalStyles();
        this.mountMobileLayer();
      }

      if (this.cardShell) {
        this.cardShell.hidden = false;
      }

      this.classList.add('is-open');
      this.button?.setAttribute('aria-expanded', 'true');
      if (this.isMobile) {
        this.showMobileLayer();
        YGDotV1.lockBodyScroll(this);
      } else {
        this.hideMobileLayer();
        if (this.mobileOverlay) {
          this.mobileOverlay.hidden = true;
        }
        this.restoreMobileLayer();
      }
      this.updatePlacement();
      requestAnimationFrame(() => this.updatePlacement());

      if (emitEvent) {
        this.dispatchState();
      }
    }

    close(emitEvent = true) {
      this.classList.remove('is-open');
      this.removeAttribute('data-placement-x');
      this.removeAttribute('data-placement-y');
      this.style.removeProperty('--dot-card-shift-x');
      this.style.removeProperty('--dot-card-shift-y');
      this.button?.setAttribute('aria-expanded', 'false');
      YGDotV1.unlockBodyScroll(this);

      if (this.isMobile || this.isUsingMobileLayer) {
        this.hideMobileLayer();
        this.queueMobileRestore();
      } else if (this.cardShell) {
        this.cardShell.hidden = true;
      }

      if (emitEvent) {
        this.dispatchState();
      }
    }

    reset() {
      if (this.isDefaultOpen) {
        this.open(false);
      } else {
        this.close(false);
      }
    }

    updatePlacement() {
      if (!this.cardShell || this.cardShell.hidden) return;

      const viewportWidth = document.documentElement.clientWidth;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const rect = this.getBoundingClientRect();
      const safeSpace = 16;
      const isMobile = window.innerWidth <= 699;
      this.style.setProperty('--dot-card-shift-x', '0px');
      this.style.setProperty('--dot-card-shift-y', '0px');

      if (isMobile) {
        this.removeAttribute('data-placement-y');
        return;
      } else {
        const cardRect = this.cardShell.getBoundingClientRect();
        const spaceRight = viewportWidth - rect.right - safeSpace;
        const spaceLeft = rect.left - safeSpace;
        const shouldOpenLeft = spaceRight < cardRect.width && spaceLeft >= spaceRight;

        this.dataset.placementX = shouldOpenLeft ? 'left' : 'right';

        const placedCardRect = this.cardShell.getBoundingClientRect();
        let shiftX = 0;

        if (placedCardRect.left < safeSpace) {
          shiftX = safeSpace - placedCardRect.left;
        } else if (placedCardRect.right > viewportWidth - safeSpace) {
          shiftX = (viewportWidth - safeSpace) - placedCardRect.right;
        }

        this.style.setProperty('--dot-card-shift-x', `${shiftX}px`);

        const centerY = rect.top + (rect.height / 2);
        const halfHeight = placedCardRect.height / 2;
        let shiftY = 0;

        if (centerY - halfHeight < safeSpace) {
          shiftY = safeSpace - (centerY - halfHeight);
        } else if (centerY + halfHeight > viewportHeight - safeSpace) {
          shiftY = (viewportHeight - safeSpace) - (centerY + halfHeight);
        }

        this.style.setProperty('--dot-card-shift-y', `${shiftY}px`);
      }
    }

    isEventInside(target) {
      return this.contains(target) || this.cardShell?.contains(target) || this.mobileOverlay === target;
    }

    get isUsingMobileLayer() {
      return this.cardShell?.parentNode === document.body;
    }

    mountMobileLayer() {
      if (!this.isMobile) return;

      this.syncPortalStyles();

      if (this.mobileOverlay && this.mobileOverlay.parentNode !== document.body) {
        document.body.appendChild(this.mobileOverlay);
      }

      if (this.cardShell && this.cardShell.parentNode !== document.body) {
        document.body.appendChild(this.cardShell);
      }
    }

    restoreMobileLayer() {
      this.restoreNode(this.mobileOverlay, this.overlayOriginParent, this.overlayOriginNextSibling);
      this.restoreNode(this.cardShell, this.cardShellOriginParent, this.cardShellOriginNextSibling);
    }

    restoreNode(node, parent, nextSibling) {
      if (!node || !parent || node.parentNode === parent) return;

      if (nextSibling && nextSibling.parentNode === parent) {
        parent.insertBefore(node, nextSibling);
      } else {
        parent.appendChild(node);
      }
    }

    showMobileLayer() {
      if (!this.isMobile) return;

      if (this.mobileOverlay) {
        this.mobileOverlay.hidden = false;
      }

      if (this.cardShell) {
        this.cardShell.hidden = false;
      }

      requestAnimationFrame(() => {
        if (!this.isOpen || !this.isMobile) return;
        this.mobileOverlay?.classList.add('is-visible');
        this.cardShell?.classList.add('is-mobile-open');
      });
    }

    hideMobileLayer() {
      this.mobileOverlay?.classList.remove('is-visible');
      this.cardShell?.classList.remove('is-mobile-open');
    }

    queueMobileRestore() {
      this.clearMobileCloseTimer();
      this.mobileCloseTimer = window.setTimeout(() => {
        this.mobileCloseTimer = null;

        if (this.isOpen) return;

        if (this.mobileOverlay) {
          this.mobileOverlay.hidden = true;
        }

        if (this.cardShell) {
          this.cardShell.hidden = true;
        }

        this.restoreMobileLayer();
      }, YGDotV1.mobileTransitionDuration);
    }

    clearMobileCloseTimer() {
      if (!this.mobileCloseTimer) return;
      window.clearTimeout(this.mobileCloseTimer);
      this.mobileCloseTimer = null;
    }

    syncPortalStyles() {
      if (!this.cardShell || !this.portalStyleSourceElement) return;

      const sourceStyles = window.getComputedStyle(this.portalStyleSourceElement);

      Array.from(sourceStyles).forEach((propertyName) => {
        if (!propertyName.startsWith('--')) return;

        const propertyValue = sourceStyles.getPropertyValue(propertyName);
        if (!propertyValue) return;

        this.cardShell.style.setProperty(propertyName, propertyValue);
      });
    }

    static lockBodyScroll(owner) {
      if (YGDotV1.activeLockOwner === owner) return;

      if (!YGDotV1.activeLockOwner) {
        YGDotV1.lockedScrollY = window.scrollY || window.pageYOffset || 0;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${YGDotV1.lockedScrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      }

      YGDotV1.activeLockOwner = owner;
    }

    static unlockBodyScroll(owner) {
      if (YGDotV1.activeLockOwner !== owner) return;

      YGDotV1.activeLockOwner = null;
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('left');
      document.body.style.removeProperty('right');
      document.body.style.removeProperty('width');
      window.scrollTo(0, YGDotV1.lockedScrollY);
    }

    dispatchState() {
      this.dispatchEvent(new CustomEvent('yg:dot-toggle', {
        bubbles: true,
        detail: {
          dot: this,
          isOpen: this.isOpen,
        },
      }));
    }
  }

  if (!window.customElements.get('yg-dot-v1')) {
    window.customElements.define('yg-dot-v1', YGDotV1);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-dropdown"] && !Shopify.designMode) return;
  try {
    class YGDropdown extends YGUtils {
    #dropdownGroup;
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
      this.debouncedResize = this.debounce(() => this.setContentContainerHeight(), 100);
    }

    get dropdownGroup() {
      if (this.#dropdownGroup) return this.#dropdownGroup;

      let groupID = this.dataset.group;
      if (!groupID) return null;

      this.#dropdownGroup = Array.from(
        this.closest('.shopify-section').querySelectorAll('yg-dropdown[data-group="' + groupID + '"]')
      );

      return this.#dropdownGroup;
    }
    connectedCallback() {
      setTimeout(() => {
        this.dropdownGroup[0]?.openDropdown();
      }, 60);
      this.titleContainer = this.querySelector('.yg-dropdown-title-container');
      if (this.titleContainer) {
        this.titleContainer.addEventListener('click', this.itemClick);
        window.addEventListener('resize', this.debouncedResize);
        this.setContentContainerHeight();
      }
    }
    disconnectedCallback() {
      if (this.titleContainer) {
        this.titleContainer.removeEventListener('click', this.itemClick);
      }
      if (this.debouncedResize) {
        window.removeEventListener('resize', this.debouncedResize);
      }
    }
    itemClick() {
      this.setContentContainerHeight();
      let group = this.dropdownGroup;
      if (group && Array.isArray(group) && this.hasAttribute('open')) {
        return;
      }

      this.hasAttribute('open') ? this.closeDropdown() : this.openDropdown();
    }

    openDropdown() {
      let group = this.dropdownGroup;
      if (group && Array.isArray(group)) {
        group.forEach((dropdown) => {
          if (dropdown !== this) {
            dropdown.closeDropdown();
          }
        });
      }

      this.setAttribute('open', '');
      document.dispatchEvent(
        new CustomEvent('YG:dropdown-open', {
          bubbles: true,
          composed: true,
          detail: {
            id: this.getAttribute('data-id'),
          },
        })
      );
    }

    closeDropdown() {
      this.removeAttribute('open');
    }

    setContentContainerHeight() {
      let contentContainer = this.querySelector('.yg-dropdown-content-container');
      let content = this.querySelector('.yg-dropdown-content');
      if (contentContainer && content) {
        contentContainer.style.setProperty('--height', `${content.getBoundingClientRect().height}px`);
      }
    }
  }
  if (!window.customElements.get('yg-dropdown')) {
    window.customElements.define('yg-dropdown', YGDropdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-gallery-pagination"] && !Shopify.designMode) return;
  try {
    class YGGalleryPagination {
    constructor(galleryId) {
      this.galleryId = galleryId;
      this.carousel = document.getElementById(galleryId);
      this.paginationElement = document.querySelector(`[data-gallery-id="${galleryId}"]`);
      
      if (this.carousel && this.paginationElement) {
        this.currentSpan = this.paginationElement.querySelector('.yg-gallery-pagination__current');
        this.init();
      }
    }

    init() {
      // Listen for carousel slide changes
      this.carousel.addEventListener('slidechange', () => this.updatePagination());
      
      // Also listen for scroll events for manual scrolling
      this.carousel.addEventListener('scroll', () => this.updatePaginationOnScroll());
      
      // Update on initial load
      this.updatePagination();
    }

    updatePagination() {
      if (this.carousel.swiper) {
        const currentIndex = this.carousel.swiper.activeIndex + 1;
        this.currentSpan.textContent = currentIndex;
      }
    }

    updatePaginationOnScroll() {
      if (this.carousel.swiper) {
        const currentIndex = this.carousel.swiper.activeIndex + 1;
        this.currentSpan.textContent = currentIndex;
      }
    }
  }

  // Initialize pagination for all galleries
  document.addEventListener('DOMContentLoaded', () => {
    const paginationElements = document.querySelectorAll('[data-gallery-id]');
    paginationElements.forEach(el => {
      const galleryId = el.getAttribute('data-gallery-id');
      new YGGalleryPagination(galleryId);
    });
  });

  // Also handle dynamic content loading
  if (window.MutationObserver) {
    const observer = new MutationObserver(() => {
      const paginationElements = document.querySelectorAll('[data-gallery-id]');
      paginationElements.forEach(el => {
        const galleryId = el.getAttribute('data-gallery-id');
        if (!el._paginationInitialized) {
          new YGGalleryPagination(galleryId);
          el._paginationInitialized = true;
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-open-popup"] && !Shopify.designMode) return;
  try {
    class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.handleActivate = this.handleActivate.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    getDirectPopupTemplate() {
      return Array.from(this.children).find((child) => child.matches('template, .yg-popup-template')) || null;
    }

    connectedCallback() {
      this.sectionsEl = {
        popupTemplate: this.getDirectPopupTemplate(),
      };

      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'button');
      }

      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }

      this.addEventListener('click', this.handleActivate);
      this.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleActivate);
      this.removeEventListener('keydown', this.handleKeydown);
    }

    getPopupTemplate() {
      if (this.sectionsEl.popupTemplate) {
        return this.sectionsEl.popupTemplate;
      }

      if (!this.dataset.popupId) {
        return null;
      }

      return document.getElementById(`yg-popup-template-${this.dataset.popupId}`);
    }

    handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      this.handleActivate();
    }

    handleActivate() {
      const popupTemplate = this.getPopupTemplate();

      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }

      this.dispatchEvent(
        new CustomEvent('YG:openPopup', {
          bubbles: true,
          detail: {
            popupTemplate,
            popupClass: this.dataset.popupClass,
            closeBtnClass: this.dataset.closeBtnClass,
          },
        })
      );
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-popup"] && !Shopify.designMode) return;
  try {
    class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    // 优化：缓存并懒加载元素，只查询一次，提高性能和可维护性
    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'close': this.querySelector('.yg-popup-box-close'),
        'content-inner': this.querySelector('.yg-popup-box-content-inner'),
        'body': document.body,
      };
      
      return this._sectionsEl;
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', this.openPopup);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', this.openPopup);
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};
      
      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      this.sectionsEl['close'].classList.add(`${closeBtnClass}`)
      this.classList.add(`${popupClass}`)
      this.sectionsEl['content-inner'].innerHTML = popupTemplate.innerHTML;
      this.sectionsEl['body'].style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.sectionsEl['content-inner'].innerHTML = '';
        this.sectionsEl['body'].style.overflow = 'auto';
        this.sectionsEl['close'].className = 'yg-popup-box-close';
        this.className = 'yg-popup-box';
      }
    } 
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-tabs"] && !Shopify.designMode) return;
  try {
    class YGTabsTitle extends YGUtils {
      constructor() {
          super()
      }

      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;

        this._sectionsEl = {
          'title-list': Array.from(this.children),
          'content-list': Array.from(document.querySelector(`yg-tabs-content[data-id='${this.dataset.id}']`)?.children || [])
        };

        return this._sectionsEl;
      }

      connectedCallback() {
        this.initTabs()
        this.addEventListener('click', (e) => {
          let item = e.target.closest('.tab-title');
          if (item) {
            let i = this.sectionsEl['title-list'].indexOf(item);
            this.itemClick(item, i);
          }
        });
      }

      initTabs() {
        this.sectionsEl['title-list']?.forEach((el, i) => {
          if (!el.classList.contains('tab-title')) {
            el.classList.add('tab-title');
          }
          
          if (i == 0) {
            el.classList.add('is-active');
          }
        });
        this.updateStyle(this.sectionsEl['title-list'][0]);

        this.sectionsEl['content-list'].forEach((el, i) => {
          if (!el.classList.contains('tab-content')) {
            el.classList.add('tab-content');
          }

          if (i == 0)  el.classList.add('is-active');
        });
      }

      itemClick(el, i) {
        // 如果已经激活则直接返回
        if (el.classList.contains('is-active')) return;

        this.scrollItemIntoView(el);
        this.toggleClass(el, i)
      }

      scrollItemIntoView(el, options = {}) {
        const scrollContainer = this.closest('.yg-scroll-container');
        if (!scrollContainer || !el) return;

        const { behavior = 'smooth' } = options;
        const containerRect = scrollContainer.getBoundingClientRect();
        const itemRect = el.getBoundingClientRect();
        const currentScrollLeft = scrollContainer.scrollLeft;
        const rawScrollLeft = currentScrollLeft + (itemRect.left - containerRect.left) - ((scrollContainer.clientWidth - itemRect.width) / 2);
        const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
        const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

        if (typeof scrollContainer.scrollTo === 'function') {
          scrollContainer.scrollTo({
            left: nextScrollLeft,
            behavior
          });
          return;
        }

        scrollContainer.scrollLeft = nextScrollLeft;
      }

      toggleClass(el, i) {
        // 处理标题激活状态
        this.sectionsEl['title-list'].forEach((item) => {
          item.classList.remove('is-active');
        });
        el.classList.add('is-active');
        this.updateStyle(el);

        // 处理内容激活状态
        this.sectionsEl['content-list'].forEach((item) => {
          item.classList.remove('is-active');
        });
        if (this.sectionsEl['content-list'][i])
          this.sectionsEl['content-list'][i].classList.add('is-active');
      }

      updateStyle(el = null) {
        let itemEl = el || this.querySelector('.is-active');

        if (!itemEl) return;
        let left = itemEl.offsetLeft;
        let width = itemEl.offsetWidth;
        this.style.setProperty('--scroll-item-left', `${left}px`);
        this.style.setProperty('--scroll-item-width', `${width}px`);
      }
  }
  if (!window.customElements.get('yg-tabs-title')) {
      window.customElements.define('yg-tabs-title', YGTabsTitle)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLazyLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.type = this.getAttribute('data-type');
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get playVideoButton() {
      return this.querySelector('.yg-play-video');
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getLazyLoader().observe(this);
      }
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.template,
            },
          })
        );

        return;
      }

      this.image?.classList.add('hide');
      this.playVideoButton?.classList.add('hide');

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        
        this.videoContainer.classList.remove('hide');
        videos.forEach(video => {
          video.play();
        });

        return;
      }

      this.appendChild(this.template?.content.cloneNode(true));
    }

    pauseVideo() {
      this.image?.classList.remove('hide');
      this.playVideoButton?.classList.remove('hide');
      
      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        this.videoContainer.classList.add('hide');

        videos.forEach(video => {
          video.pause();
          video.currentTime = 0;
        });
      } else {
        this.videoContainer?.remove();
      }
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
